import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SignalRService } from '../../../../services/signal-r/signal-r.service';
import { SignalRAction } from '../../../../services/signal-r/signalr-enums';
import * as RoleActions from 'src/app/components/catalogs/roles/store/role.action';
import { Channels } from 'src/app/store/channels';
import { GeneralSignalRResponse } from '../../../../services/signal-r/general-signal-r-response';

@Injectable({
  providedIn: 'root',
})
export class RoleStoreAndListenersService {
  constructor(
    private store: Store,
    private signalRService: SignalRService,
  ) {}

  initStore() {
    this.store.dispatch(new RoleActions.RoleRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(
      Channels.ROLE,
      (data: GeneralSignalRResponse) => {
        this.signalRService.setSender(data.userID);
        switch (data.action) {
          case SignalRAction.Add:
            this.store.dispatch(new RoleActions.RoleCreate(data.obj));
            break;

          case SignalRAction.Update:
            this.store.dispatch(new RoleActions.RoleUpdate(data.id, data.obj));
            break;

          case SignalRAction.Delete:
            this.store.dispatch(new RoleActions.RoleDelete(data.id));
            break;

          case SignalRAction.Get:
            this.store.dispatch(new RoleActions.RoleRefresh());
            break;

          case SignalRAction.RequestRefresh:
            this.store.dispatch(new RoleActions.RoleRefreshByID(data.id));
            break;
        }
      },
    );
  }
}
